__turbopack_context__.v({
  "baseline": "SalesPage-module__-vaWEa__baseline",
  "brand": "SalesPage-module__-vaWEa__brand",
  "brandName": "SalesPage-module__-vaWEa__brandName",
  "capabilities": "SalesPage-module__-vaWEa__capabilities",
  "capability": "SalesPage-module__-vaWEa__capability",
  "closing": "SalesPage-module__-vaWEa__closing",
  "faq": "SalesPage-module__-vaWEa__faq",
  "faqItem": "SalesPage-module__-vaWEa__faqItem",
  "faqList": "SalesPage-module__-vaWEa__faqList",
  "footer": "SalesPage-module__-vaWEa__footer",
  "footerMark": "SalesPage-module__-vaWEa__footerMark",
  "header": "SalesPage-module__-vaWEa__header",
  "headline": "SalesPage-module__-vaWEa__headline",
  "hero": "SalesPage-module__-vaWEa__hero",
  "heroCtas": "SalesPage-module__-vaWEa__heroCtas",
  "heroPrimary": "SalesPage-module__-vaWEa__heroPrimary",
  "kicker": "SalesPage-module__-vaWEa__kicker",
  "nav": "SalesPage-module__-vaWEa__nav",
  "navLink": "SalesPage-module__-vaWEa__navLink",
  "plan": "SalesPage-module__-vaWEa__plan",
  "planCta": "SalesPage-module__-vaWEa__planCta",
  "planFeatured": "SalesPage-module__-vaWEa__planFeatured",
  "planGrid": "SalesPage-module__-vaWEa__planGrid",
  "planList": "SalesPage-module__-vaWEa__planList",
  "planName": "SalesPage-module__-vaWEa__planName",
  "planPer": "SalesPage-module__-vaWEa__planPer",
  "planPrice": "SalesPage-module__-vaWEa__planPrice",
  "planPricePending": "SalesPage-module__-vaWEa__planPricePending",
  "planTag": "SalesPage-module__-vaWEa__planTag",
  "planTagline": "SalesPage-module__-vaWEa__planTagline",
  "plans": "SalesPage-module__-vaWEa__plans",
  "pricingNote": "SalesPage-module__-vaWEa__pricingNote",
  "root": "SalesPage-module__-vaWEa__root",
  "sectionSub": "SalesPage-module__-vaWEa__sectionSub",
  "sectionTitle": "SalesPage-module__-vaWEa__sectionTitle",
  "sub": "SalesPage-module__-vaWEa__sub",
});
